import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Ramo } from './Ramo';

@Injectable({
  providedIn: 'root'
})
export class ConfiguracionesService {
  public arrayRamos : Ramo[];

  constructor(){}

  async consultarTopexRamo (ramo : number){
    let url = new URL(`${environment.backendUrl}/api/Ramo/ConsultarTopexRamo`);
        let parameters={
            ramo: ramo
        };
        Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));
        return await (await fetch(url.toString(), {method: 'GET'})).json();
  }

  async actualizarTopeXRamo(ramo: number, nuevoTope: number){
    let url = new URL(`${environment.backendUrl}/api/Ramo/ActualizarTopexRamo`);
    let parameters = {
      ramo: ramo,
      nuevoTope: nuevoTope
    };
    Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));
    return await (await fetch(url.toString(), { method: 'POST' })).json();
  }


}
